import { ComponentProps } from "react";
import { Input, Textarea } from "@altimateai/lego";

export function CustomInput(props: ComponentProps<typeof Input>) {
  return <Input className="custom-input" {...props} />;
}

export function CustomMultilineInput(props: Omit<ComponentProps<typeof Textarea>, "rows">) {
  return <Textarea className="custom-input" {...props} rows={4} />;
}
